<script>
  import ListInfinity from '@components/ListInfinity'
  export let title, list, breadcrumbs
</script>

  <ListInfinity
    {title}
    {list}
    {breadcrumbs}
  />
